// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyPlaceHolder_root__3p7Dt"};